export var phoneInputContainer = function phoneInputContainer(hasValidation) {
  return {
    display: 'flex',
    width: '100%',
    marginBottom: hasValidation ? 6 : 0
  };
};
export var phoneInputCountrySelect = {
  flex: '1 0 120px',
  marginRight: 8
};